module.exports = "/_next/static/images/about-advance-ae55ebd4301c18951bc66767d54d4230.svg";